import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const TooltipContentPre = styled.pre`
  background-color: ${colors.white};
  border: none;
  display: block;
  font-family: 'LLCircularWeb-Book', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 16px;
  width: 434px;
  word-break: normal;
`;

export default TooltipContentPre;
